import { render, staticRenderFns } from "./OfficialAccount.vue?vue&type=template&id=e4eeee98&scoped=true&"
import script from "./OfficialAccount.vue?vue&type=script&lang=js&"
export * from "./OfficialAccount.vue?vue&type=script&lang=js&"
import style0 from "./OfficialAccount.vue?vue&type=style&index=0&id=e4eeee98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4eeee98",
  null
  
)

export default component.exports